var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"primary"},[_vm._v(" 试用请联系微信客服 ")])}
var staticRenderFns = []

export { render, staticRenderFns }